var standalone = false;

function textareaRestricted(conf) {
    if (!conf) { conf = {} }
    
    var root = conf.target || $("[data-component='textarea-restricted']");

    if (root.length > 0) {
        var defaults = {
            "maxlength": conf.maxlength || 1,
            "maxlength-allow-negative": conf["maxlength-allow-negative"] || true,
            "maxlength-force": conf["maxlength-force"] || true,
            "mode": conf["mode"] || "textarea"
        }

        var textNode = root.find('.help .label').contents().first();
        app.helpers.funcs.replaceCharacterPlaceholderWithElement(textNode);

        var el = {
            text: root.find(defaults.mode),
            remaining: root.find('.help .value')
        }
        /*
		* How muny chars remain
		*/
        function remaining() {
            var cSharpInter = /[{|}]/g;
            //if getting values from c sharp then sanitize
            if (root.data("maxlength") && typeof root.data("maxlength") === "string" && cSharpInter.test(root.data("maxlength"))) {
                root.data().maxlength = parseInt(root.data("maxlength").replace(cSharpInter, ""));
            }

            var max = defaults.maxlength;
            if (root.data().hasOwnProperty("maxlength") && root.data().maxlength != null && root.data().maxlength != null) {
                max = root.data().maxlength;
            }
            var at = el.text.val().length;
            var char = (max - at);
            //@inputs
            var goNegative = root.data("maxlength-allow-negative") || defaults["maxlength-allow-negative"];
            var forceTypeLimit = root.data("maxlength-force") || "maxlength-force";

            if (forceTypeLimit === true) {
                el.text.attr("maxlength", root.data("maxlength"));
            }

            if (goNegative === true) {
                el.remaining.text(char);
            }
            else {
                if (parseInt(char) <= 0) {
                    el.remaining.text(0);
                }
                else {
                    el.remaining.text(char);
                }
            }
        }
        //char check
        remaining();
        $(document).on("keyup", el.text[0].selector, remaining);
    }
}

//standalone
if (standalone) {
    $(function () {
        textareaRestricted();
    });
}

//as plugin
(function ($, textareaRestricted) {
    $.fn.restrictedText = function (options) {
        var self = this;
        //do not initialize here
        options.target = self;
        textareaRestricted(options)
    }
}(jQuery, textareaRestricted));